<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/researcher/newElite'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <div class="d-flex justify-content-center mt-3"></div>
      <b-tabs class="mb-3" pills vertical v-model="tabIndex">
        <b-tab :title="'حمایت های پیشین از نخبه وظیفه'" active>
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">حمایت از نخبگان وظیفه</h4>
            </template>
            <b-form-group>
              <div class="d-flex float-start" dir="ltr">
                <label
                  for="switch_1"
                  class="ml-3 mb-0"
                  :class="initial.initialObligation ? 'done' : 'required'"
                  ><p>
                    اينجانب تعهد می‌کنم پس از احراز نخبگی توسط بنياد ملی نخبگان،
                    اقدام به تكميل اطلاعات و درخواست گذراندن طرح جايگزين خدمت
                    سربازی نموده ام
                  </p></label
                >
                <b-form-checkbox
                  id="switch_1"
                  v-model="initial.initialObligation"
                ></b-form-checkbox>
              </div>
            </b-form-group>
            <hr />
            <h3 class="text-primary mb-4">متقاضی گرامی</h3>

            <p>
              به ابزار حمایت از مقالات سامانه تقسیم کار ملی خوش آمدید.
              خواهشمندیم ابتدا به سوالات زیر پاسخ دهید:
            </p>
            <b-form-group
              label="آیا شما از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده‌اید؟"
              :class="initial.initialIsSupported !== null ? 'done' : 'required'"
            >
              <b-form-radio-group v-model="initial.initialIsSupported">
                <b-form-radio :value="true">بله</b-form-radio>
                <b-form-radio :value="false">خیر</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="حمایت ها:"
              v-if="initial.initialIsSupported"
              :class="initial.initialSupportedType ? 'done' : 'required'"
            >
              <b-form-select
                class="myselect2"
                id="first"
                v-model="initial.initialSupportedType"
                :options="options"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="عنوان حمایت دریافتی"
              v-if="
                initial.initialSupportedType == 'other' &&
                initial.initialIsSupported
              "
              :class="initial.initialOtherSupport ? 'done' : 'required'"
            >
              <b-form-input
                trim
                type="text"
                v-model="initial.initialOtherSupport"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="توضیحات حمایت دریافتی:"
              v-if="initial.initialIsSupported"
              :class="initial.initialSupportDescription ? 'done' : 'required'"
            >
              <b-form-textarea
                trim
                rows="6"
                v-model="initial.initialSupportDescription"
              >
              </b-form-textarea>
            </b-form-group>
          </b-card>
        </b-tab>
        <b-tab disabled :title="'اطلاعات نخبه وظیفه'"></b-tab>
        <b-tab disabled :title="'مشخصات طرح جایگزین خدمت '"></b-tab>
        <b-tab disabled :title="'زمان‌بندی'"></b-tab>
        <b-tab disabled :title="'هزینه‌ها'"></b-tab>
        <b-tab disabled :title="'تعهدات'"></b-tab>
        <b-tab disabled :title="'مرور نهایی و ارسال'"></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <!-- NOTE (b-start) To begin the proposal registration process -->
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="
            !initial.initialObligation ||
            initial.initialIsSupported === null ||
            (initial.initialIsSupported && !initial.initialSupportedType) ||
            (initial.initialIsSupported &&
              !initial.initialSupportDescription) ||
            (initial.initialIsSupported &&
              initial.initialSupportedType == 'other' &&
              !initial.initialOtherSupport)
          "
          >آغاز فرایند</b-button
        >
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
  },
  data() {
    return {
      moment: moment,
      tabIndex: 1,
      initial: { initialIsSupported: null },
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      isLoaded: true,
    };
  },

  methods: {
    start() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      // NOTE (m-start) to save drafts in each step
      this.isSaving = true;

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/elite/new",
          {
            initialObligation: this.initial.initialObligation,
            initialIsSupported: this.initial.initialIsSupported,
            initialSupportedType: this.initial.initialSupportedType,
            initialOtherSupport: this.initial.initialOtherSupport,
            initialSupportDescription: this.initial.initialSupportDescription,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          router.push("/researcher/completeElite/" + res.data);
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
</style>
